import { Message } from "shared/components/Message";
import React, { FC } from "react";
import { MessageDescriptor } from "react-intl";
import { Link } from "react-router-dom";
import { Card, CardBody, CardText } from "reactstrap";

interface ILicenceOptionCardProps {
    className?: string;
    navDescriptionText: MessageDescriptor;
    navButtonText: MessageDescriptor;
    navigateTo: string;
}

export const LicenceOptionCard: FC<ILicenceOptionCardProps> = ({ navDescriptionText, navButtonText, navigateTo, className }) => {
    const buttonRef = className ? className.concat("Button") : "defaultButton";
    const headingId = className ? className.concat("Heading") : "defaultHeading";

    return (
        <Card
            tag="article"
            body={true}
            outline={true}
            className="mx-auto my-2"
            aria-labelledby={headingId}
        >
            <CardBody>
                <h2 id={headingId} className="sr-only">
                    <Message message={navButtonText} />
                </h2>

                <CardText className="mb-4">
                    <Message message={navDescriptionText} />
                </CardText>

                <Link
                    to={navigateTo}
                    data-cy={buttonRef}
                    className="btn btn-primary btn-block"
                    role="button"
                >
                    <Message message={navButtonText} />
                </Link>
            </CardBody>
        </Card>
    );
};
